import { render, staticRenderFns } from "./tipo-deficiencia-deficiente-visual.vue?vue&type=template&id=31d51726&"
import script from "./tipo-deficiencia-deficiente-visual.vue?vue&type=script&lang=ts&"
export * from "./tipo-deficiencia-deficiente-visual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d51726')) {
      api.createRecord('31d51726', component.options)
    } else {
      api.reload('31d51726', component.options)
    }
    module.hot.accept("./tipo-deficiencia-deficiente-visual.vue?vue&type=template&id=31d51726&", function () {
      api.rerender('31d51726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa-deficiente-visual/tipo-deficiencia-deficiente-visual.vue"
export default component.exports